import { Injectable } from "@angular/core";
import { Router, CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { environment } from "../../../environments/environment";
import { DomainService } from "./domain.service";

@Injectable()
export class PublicDomainGuard implements CanActivate {
    constructor(private router: Router, private domainService: DomainService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        if (!environment.subdomains) {
            return this.domainService.validateLocalRoute(state.url);
        }

        return this.domainService.validateRoute(state.url, "map");
    }
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/common/guards/public-domain.guard.ts